<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Your Blueprint for Life: How to Align Your Passion, Gifts, and Calling With Eternity In Mind</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct" id="p0023-01-0"><a id="page15"></a><a href="#/contents#con5" id="toc5"><i>Chapter Two</i></a></p>
<p class="line"></p>
<p class="ct1"><a href="#/contents#con5">WHY AM I HERE?</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?50af8b8a